import { RepositoryFirebase } from "../common/repository.firebase";
import { CustomerAccount } from "./customer-account.entity";

class CustomerAccountRepository extends RepositoryFirebase<CustomerAccount> {
  protected collection = "customer-accounts";
  protected entity = CustomerAccount;

  async getByCustomerId(customerId: string) {
    return await this.findByIdOrNull(customerId);
  }

  async listByCustomerIds(customerIds: string[]) {
    const result = new Map<string, CustomerAccount>();
    await Promise.all(
      customerIds.map(async (customerId) => {
        const account = await this.getByCustomerId(customerId);
        if (account) result.set(customerId, account);
      })
    );
    return result;
  }
}

export const customerAccountRepository = new CustomerAccountRepository();
